<template>
    
    <div id="home-map-container">

        

        <div class="image-home-map">

            <img :src="images.cpFoshan" id="image-home-cp-foshan" />

            <img :src="images.cpZhongshan" id="image-home-cp-zhongshan" />

            <img :src="images.cpAomen" id="image-home-cp-aomen" />

            <img :src="images.cpHongkong" id="image-home-cp-hongkong" />

            <img :src="images.cpDongguan" id="image-home-cp-dongguan" />
        </div>

        <div :id="containerId"></div>
    </div>
</template>

<script>

    import $ from "jquery";

    import mapSVG from "@/assets/images/home/map.svg";
    import ImageCpFoshan from "@/assets/images/home/cp-foshan.png";
    import ImageCpZhongshan from "@/assets/images/home/cp-zhongshan.png";
    import ImageCpAomen from "@/assets/images/home/cp-aomen.png";
    import ImageCpHongKong from "@/assets/images/home/cp-hongkong.png";
    import ImageCpDongGuan from "@/assets/images/home/cp-dongguan.png";

    export default {
        name: "HomeMap",
        data() {

            return {
                containerId: "home-map",
                chart: null,
                options: null,
                nanshaSVG: null,
                images: {
                    cpFoshan: ImageCpFoshan,
                    cpZhongshan: ImageCpZhongshan,
                    cpAomen: ImageCpAomen,
                    cpHongkong: ImageCpHongKong,
                    cpDongguan: ImageCpDongGuan
                }
            };
        },
        mounted() {
            this.initEchartMap();
        },
        methods: {
            initEchartMap() {

                const chartDom = document.getElementById(this.containerId);

                this.chart = this.$echarts.init(chartDom);

                this.drawMap();
            },
            drawMap() {

                const that = this;

                $.get(mapSVG, svg => {
                    
                    that.$echarts.registerMap("NanSha", { svg });

                    that.options = {
                        geo: {
                            map: "NanSha"
                        },
                        series: [
                            {
                                type: "scatter",
                                coordinateSystem: 'geo',
                                itemStyle: {
                                    color: '#FFFFFF'
                                },
                                rippleEffect: {
                                    scale: 13,
                                    color: "#FFFFFF"
                                },
                                symbolSize: 25,
                                symbol: "image://https://s3.bmp.ovh/imgs/2022/06/23/4664a0100da98724.png",
                                data: [
                                    [190, 330],
                                    [250, 420],
                                    [280, 460],
                                    [395, 575],
                                    [400, 520],
                                    [450, 530],
                                    [435, 560],
                                    [500, 600],
                                    [600, 590],
                                    [525, 460],
                                    [425, 320],
                                    [390, 290],
                                    [360, 260],
                                    [320, 270],
                                    [300, 310],
                                    [100, 320]
                                ],
                                z: 1
                            },
                            {
                                type: "effectScatter",
                                coordinateSystem: 'geo',
                                itemStyle: {
                                    color: 'rgba(249, 255, 219, 0.4)'
                                },
                                symbolSize: 48,
                                rippleEffect: {
                                    scale: 2
                                },
                                data: [
                                    [480, 490]
                                ],
                                z: 3
                            },
                            {
                                type: "scatter",
                                coordinateSystem: 'geo',
                                symbolSize: 50,
                                symbol: "image://https://s3.bmp.ovh/imgs/2022/06/21/850cf1c5408d363f.png",
                                symbolKeepAspect: true,
                                data: [
                                    [480, 490]
                                ],
                                z: 10
                            }
                        ]
                    };

                    that.options && this.chart.setOption(this.options);
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

    @media screen and (min-height: 800px) {

        #home-map-container {

            position: fixed;
            left: calc((100% - 500px) / 2);
            top: 26%;
            width: 100vw;
            height: 100vh;

            #home-map {
                height: 500px;
                width: 500px;
                position: fixed;
                left: calc((100% - 500px) / 2);
                top: 28%;
            }

            .image-home-map {
                background-position: 50% 50%;
                width: 400px;
                height: 400px;
                background-size: contain;
                background-repeat: no-repeat;
                position: fixed;
                left: calc((100% - 400px) / 2);
                top: 34%;
            }

            #image-home-cp-foshan {
                position: relative;
                top: 48.3%;
                left: 5%;
                width: 16.8%;
            }

            #image-home-cp-zhongshan {
                position: relative;
                top: 62%;
                left: 12%;
                width: 17.8%;
            }

            #image-home-cp-aomen {
                position: relative;
                top: 78.6%;
                left: 21%;
                width: 12.3%;
            }

            #image-home-cp-hongkong {
                position: relative;
                top: 50.9%;
                left: 37%;
                width: 14.8%;
            }

            #image-home-cp-dongguan {
                position: relative;
                top: 20.2%;
                right: 5%;
                width: 19.6%;
            }
        }
    }

    @media screen and (max-height: 800px) {

        #home-map-container {

            position: fixed;
            left: calc((100% - 500px) / 2);
            top: 26%;
            width: 100vw;
            height: 100vh;

            #home-map {
                height: 450px;
                width: 450px;
                position: fixed;
                left: calc((100% - 450px) / 2);
                top: 26.5%;
            }

            .image-home-map {
                background-position: 50% 50%;
                width: 350px;
                height: 350px;
                background-size: contain;
                background-repeat: no-repeat;
                position: fixed;
                left: calc((100% - 350px) / 2);
                top: 32%;
            }

            #image-home-cp-foshan {
                position: relative;
                top: 51.3%;
                left: 8%;
                width: 16.8%;
            }

            #image-home-cp-zhongshan {
                position: relative;
                top: 67%;
                left: 14%;
                width: 17.8%;
            }

            #image-home-cp-aomen {
                position: relative;
                top: 85.7%;
                left: 21.5%;
                width: 12.3%;
            }

            #image-home-cp-hongkong {
                position: relative;
                top: 53%;
                left: 32%;
                width: 14.8%;
            }

            #image-home-cp-dongguan {
                position: relative;
                top: 24.2%;
                right: 4.5%;
                width: 19.6%;
            }
        }
    }
</style>